import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-minus', 'CircleMinus', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M9 12l6 0"}]]);